import script from "./select-widget-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./select-widget-ly.vue?vue&type=script&setup=true&lang=js"

import "./select-widget-ly.vue?vue&type=style&index=0&id=08caeee2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08caeee2"]])

export default __exports__